module.exports = __webpack_public_path__ + "static/media/close.a1b271af.png";